import React from "react";
import { HashLink } from "react-router-hash-link";

import BotonSecundario from "../base/BotonSecundario";
import Container from "../base/Container";
import { CorteDesktop, CorteMobile } from "../base/Cortes";
import {
  StyledContainer,
  Card,
  Experience,
  Partnership,
  Technology,
} from "./MeetYourLanguageComp";
import IlustracionAbout from "../../assets/Ilustracion-About";
import OndasLargas from "../../assets/OndasLargas";
import { CardContainer, SVGContainer } from "../home/WhyUSHComp";
import { useTheme } from "styled-components";
import { colors } from "../base/breakpoints";

function MeetYourLanguage() {
  const theme = useTheme();

  return (
    <>
      <Container>
        <StyledContainer>
          <h1 className="h1-mobile h1-web mb-20-mobile mb-30 text-center">
            Meet your language
            <CorteDesktop />
            <CorteMobile /> service partner
          </h1>
          <p className="txt-regular-mobile destacado-regular mb-40-mobile mb-30 text-center">
            We deliver multilingual solutions to help you face and solve your
            global challenges.
            <CorteDesktop />
            We can blend linguistic, technical, marketing and cultural
            requirements to offer
            <CorteDesktop /> an optimized translation and localization solution.
          </p>
          <HashLink smooth to="/about#contact">
            <BotonSecundario>Get in touch</BotonSecundario>
          </HashLink>
        </StyledContainer>
      </Container>
      <IlustracionAbout />
      <Container>
        <CardContainer className="mb-30">
          <Card>
            <SVGContainer className="mb-35 mb-16-mobile">
              <Experience
                xmlns="http://www.w3.org/2000/svg"
                width="39"
                height="38"
                viewBox="0 0 39 38"
                fill="none"
              >
                <path
                  d="M26.8357 11.4178L37.2864 13.0376C38.645 13.2467 39.1675 14.9188 38.1747 15.9116L30.4935 23.2271C30.0755 23.5928 29.9187 24.1676 30.0232 24.6902L31.6953 35.1408C31.9043 36.4994 30.4935 37.5445 29.2394 36.8652L19.9383 31.8489C19.468 31.5876 18.8932 31.5876 18.3707 31.8489L8.96507 36.7084C7.71098 37.3355 6.30014 36.2904 6.56141 34.9318L8.44253 24.5334C8.54704 24.0109 8.39028 23.4361 7.97225 23.0703L0.500009 15.5458C-0.492806 14.553 0.0819815 12.8809 1.44057 12.7241L11.9435 11.3133C12.466 11.261 12.9363 10.8952 13.1976 10.425L18.0049 0.914843C18.632 -0.33924 20.4086 -0.286985 20.9834 0.967097L25.5817 10.5295C25.7907 10.9998 26.261 11.3655 26.8357 11.4178Z"
                  fill={
                    theme.nombre === "light" ? colors.azulush : colors.amarillo
                  }
                />
              </Experience>
            </SVGContainer>
            <h3 className="title-card mb-35 body-bold-mobile mb-16-mobile">
              Experience
            </h3>
            <p className="texto-regular text-center txt-regular-mobile">
              We really know our stuff. With more
              <CorteDesktop />
              than 20 years in the language
              <CorteDesktop />
              services industry, we have the
              <CorteDesktop />
              capacity to build and maintain
              <CorteDesktop />
              on-site dedicated teams
              <CorteDesktop />
              of highly skilled professionals
              <CorteDesktop />
              for your account.
            </p>
          </Card>
          <Card>
            <SVGContainer className="mb-35 mb-16-mobile">
              <Technology
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="45"
                viewBox="0 0 44 45"
                fill="none"
              >
                <path
                  d="M6.65686 30.4545L3.28698 32.5443C3.05075 32.6891 2.8816 32.9219 2.81694 33.1913C2.75227 33.4608 2.7973 33.7448 2.94207 33.9811C3.0328 34.1383 3.16298 34.2691 3.31963 34.3607C3.47629 34.4523 3.654 34.5016 3.83546 34.5036C4.02043 34.4985 4.20072 34.4444 4.35793 34.3468L7.72271 32.257C7.95894 32.1122 8.12795 31.8794 8.19262 31.61C8.25728 31.3405 8.21226 31.0565 8.06749 30.8202C7.92629 30.5875 7.69992 30.4191 7.43647 30.3508C7.17303 30.2825 6.89331 30.3197 6.65686 30.4545Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M6.29156 23.4951C6.29156 23.218 6.18139 22.9522 5.98543 22.7563C5.78947 22.5603 5.52376 22.4502 5.24663 22.4502H1.0669C0.789771 22.4502 0.52394 22.5603 0.327977 22.7563C0.132015 22.9522 0.0219727 23.218 0.0219727 23.4951C0.0219727 23.7723 0.132015 24.038 0.327977 24.234C0.52394 24.43 0.789771 24.5401 1.0669 24.5401H5.24663C5.52376 24.5401 5.78947 24.43 5.98543 24.234C6.18139 24.038 6.29156 23.7723 6.29156 23.4951Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M3.26701 14.2371L6.63166 16.4314C6.80077 16.5429 6.99866 16.6028 7.20119 16.6039C7.37555 16.6041 7.54713 16.5608 7.70044 16.4777C7.85375 16.3947 7.98387 16.2746 8.0789 16.1284C8.15411 16.0135 8.20598 15.8849 8.23145 15.75C8.25693 15.615 8.25551 15.4764 8.22737 15.342C8.19923 15.2076 8.14489 15.08 8.06742 14.9667C7.98995 14.8533 7.89081 14.7563 7.77583 14.6812L4.40595 12.4868C4.29074 12.4119 4.16187 12.3604 4.02673 12.3353C3.89158 12.3102 3.75286 12.312 3.61842 12.3407C3.48399 12.3693 3.35648 12.4242 3.24328 12.5022C3.13009 12.5801 3.03337 12.6797 2.95871 12.7951C2.80896 13.0274 2.75731 13.3095 2.81508 13.5797C2.87285 13.85 3.03538 14.0864 3.26701 14.2371Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M11.6633 9.38882C11.7591 9.53233 11.8889 9.64991 12.0412 9.73105C12.1934 9.81219 12.3634 9.85436 12.536 9.85382C12.7426 9.85325 12.9443 9.79142 13.1158 9.67617C13.2303 9.59985 13.3286 9.50167 13.405 9.38729C13.4814 9.2729 13.5345 9.14458 13.5612 9.00963C13.5879 8.87468 13.5877 8.73578 13.5606 8.60091C13.5335 8.46605 13.48 8.33788 13.4032 8.22373L11.0887 4.77544C10.9338 4.54661 10.6946 4.38847 10.4234 4.3356C10.1522 4.28272 9.87099 4.33943 9.64147 4.49332C9.4118 4.64741 9.25259 4.88628 9.19873 5.15756C9.14487 5.42884 9.20071 5.71041 9.35409 5.94056L11.6633 9.38882Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M20.9987 8.28625C11.6779 8.28625 7.35186 16.2591 7.25782 21.9226C7.169 27.4242 10.1209 30.4963 11.704 32.1473C12.8292 33.3944 13.7608 34.8033 14.4679 36.327V45.2664C14.4678 45.4042 14.4949 45.5408 14.5478 45.6681C14.6008 45.7955 14.6784 45.9111 14.7762 46.0083L17.5922 48.8296C17.6898 48.9264 17.8056 49.0031 17.9329 49.0551C18.0602 49.1071 18.1965 49.1334 18.3341 49.1326H23.6581C23.7956 49.1334 23.9319 49.1071 24.0592 49.0551C24.1866 49.0031 24.3023 48.9264 24.3999 48.8296L27.2212 46.0083C27.3181 45.9106 27.3947 45.7948 27.4467 45.6675C27.4987 45.5402 27.5251 45.4039 27.5243 45.2664V36.3479C28.2304 34.8237 29.1621 33.4146 30.2881 32.1681C31.8555 30.5171 34.8232 27.466 34.7343 21.9435C34.6351 16.2591 30.3143 8.28625 20.9987 8.28625ZM20.9987 37.6384H25.4344V38.4116H16.5525V37.6384H20.9987ZM18.1251 28.0511H17.5504C16.5577 28.0511 16.5577 27.7481 16.5577 27.398C16.5577 26.4262 17.1585 26.3061 17.681 26.3061C17.8847 26.3061 17.9422 26.3583 17.9579 26.3792C18.0822 26.5753 18.1408 26.8059 18.1251 27.0376V28.0511ZM20.215 30.141H21.7824V35.5485H20.215V30.141ZM23.8723 27.048C23.8579 26.8132 23.9163 26.5797 24.0395 26.3792C24.0395 26.3792 24.1126 26.3061 24.3164 26.3061C24.8389 26.3061 25.4397 26.4262 25.4397 27.398C25.4397 27.7481 25.4397 28.0511 24.447 28.0511H23.8775V27.1107C23.8775 27.1107 23.8618 27.0689 23.8618 27.048H23.8723ZM21.0039 44.1378H16.563V43.3489H25.4449V44.1222L21.0039 44.1378ZM21.0039 40.4806H25.4397V41.2591H16.5577V40.4858L21.0039 40.4806ZM23.2349 47.0428H18.773L17.937 46.2068H24.0656L23.2349 47.0428ZM28.7886 30.6791C27.4807 32.1209 26.4039 33.7564 25.5964 35.5276H23.8775V30.141H24.447C26.3801 30.141 27.5295 29.096 27.5295 27.398C27.5517 26.9717 27.4834 26.5454 27.3294 26.1473C27.1753 25.7491 26.9389 25.3879 26.6355 25.0875C26.3321 24.7871 25.9687 24.5542 25.569 24.4041C25.1693 24.2539 24.7425 24.1899 24.3164 24.2162C23.9811 24.2055 23.6471 24.2655 23.3365 24.3925C23.0259 24.5194 22.7456 24.7103 22.5138 24.9529C22.0023 25.5638 21.7427 26.3465 21.7876 27.142V28.0511H20.2202V27.1525C20.2599 26.3577 20.0009 25.5768 19.4941 24.9634C19.2612 24.7207 18.98 24.5297 18.6685 24.4027C18.3571 24.2758 18.0223 24.2159 17.6862 24.2267C17.2601 24.2003 16.8333 24.2643 16.4336 24.4145C16.034 24.5646 15.6705 24.7976 15.3671 25.098C15.0638 25.3984 14.8273 25.7595 14.6732 26.1577C14.5192 26.5559 14.4509 26.9821 14.4731 27.4085C14.4731 29.1274 15.6225 30.1514 17.5556 30.1514H18.1304V35.559H16.4062C15.6008 33.7866 14.5238 32.1508 13.214 30.7105C11.3122 28.7251 9.28499 26.2486 9.35291 21.9696C9.41561 18.1922 12.3467 10.3865 21.0039 10.3865C29.6612 10.3865 32.587 18.1922 32.6497 21.9696C32.7072 26.2382 30.6799 28.7199 28.7782 30.7L28.7886 30.6791Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M38.696 32.5286L35.3312 30.4387C35.2144 30.366 35.0843 30.3171 34.9485 30.2948C34.8126 30.2725 34.6736 30.2773 34.5396 30.3088C34.4056 30.3404 34.2793 30.3981 34.1677 30.4787C34.0561 30.5592 33.9614 30.6611 33.8892 30.7783C33.7445 31.0146 33.6996 31.2987 33.7642 31.5681C33.8289 31.8376 33.9979 32.0703 34.2341 32.2151L37.604 34.305C37.7612 34.4026 37.9415 34.4566 38.1265 34.4617C38.308 34.4597 38.4858 34.4105 38.6424 34.3188C38.7991 34.2272 38.9292 34.0964 39.0199 33.9392C39.1584 33.7078 39.2021 33.4317 39.1417 33.1687C39.0813 32.9058 38.9217 32.6764 38.696 32.5286Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M40.9312 22.4502H36.7515C36.4743 22.4502 36.2086 22.5603 36.0127 22.7563C35.8167 22.9522 35.7065 23.218 35.7065 23.4951C35.7065 23.7723 35.8167 24.038 36.0127 24.234C36.2086 24.43 36.4743 24.5401 36.7515 24.5401H40.9312C41.2083 24.5401 41.4742 24.43 41.6701 24.234C41.8661 24.038 41.9761 23.7723 41.9761 23.4951C41.9761 23.218 41.8661 22.9522 41.6701 22.7563C41.4742 22.5603 41.2083 22.4502 40.9312 22.4502Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M34.7821 16.6039C34.9847 16.6028 35.1826 16.5429 35.3517 16.4314L38.7216 14.2371C38.9523 14.0855 39.1138 13.8488 39.1706 13.5786C39.2273 13.3084 39.1749 13.0267 39.0246 12.7951C38.95 12.6797 38.8533 12.5801 38.7401 12.5022C38.6269 12.4242 38.4994 12.3693 38.3649 12.3407C38.2305 12.312 38.0918 12.3102 37.9566 12.3353C37.8215 12.3604 37.6926 12.4119 37.5774 12.4868L34.2127 14.6812C34.0973 14.7558 33.9977 14.8525 33.9197 14.9657C33.8418 15.0789 33.7869 15.2064 33.7583 15.3408C33.7296 15.4753 33.7278 15.614 33.7529 15.7492C33.778 15.8843 33.8295 16.0132 33.9044 16.1284C33.9995 16.2746 34.1296 16.3947 34.2829 16.4777C34.4362 16.5608 34.6078 16.6041 34.7821 16.6039Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M28.8669 9.69695C29.0399 9.81319 29.2436 9.87504 29.452 9.87457C29.6236 9.87426 29.7926 9.83166 29.9438 9.75056C30.0951 9.66946 30.2241 9.55234 30.3194 9.40957L32.6286 5.96131C32.782 5.73116 32.8379 5.44959 32.784 5.17831C32.7301 4.90703 32.5709 4.66816 32.3412 4.51407C32.1117 4.36018 31.8307 4.30347 31.5595 4.35635C31.2882 4.40922 31.0489 4.56739 30.894 4.79622L28.5847 8.24448C28.5077 8.35832 28.454 8.48624 28.4264 8.6209C28.3989 8.75556 28.3982 8.89431 28.4244 9.02923C28.4506 9.16415 28.5032 9.29261 28.5791 9.40718C28.655 9.52175 28.7529 9.62022 28.8669 9.69695Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
                <path
                  d="M20.9995 7.12127C21.2767 7.12127 21.5425 7.0112 21.7384 6.81524C21.9344 6.61927 22.0445 6.35347 22.0445 6.07634V1.89662C22.0445 1.61948 21.9344 1.35372 21.7384 1.15775C21.5425 0.96179 21.2767 0.851685 20.9995 0.851685C20.7224 0.851685 20.4566 0.96179 20.2606 1.15775C20.0646 1.35372 19.9546 1.61948 19.9546 1.89662V6.07634C19.9546 6.35347 20.0646 6.61927 20.2606 6.81524C20.4566 7.0112 20.7224 7.12127 20.9995 7.12127Z"
                  fill={
                    theme.nombre === "light" ? colors.rojoush : colors.rosaush
                  }
                />
              </Technology>
            </SVGContainer>
            <h3 className="title-card mb-35 body-bold-mobile mb-16-mobile">
              Technology
            </h3>
            <p className="texto-regular text-center txt-regular-mobile">
              We're geeks! We strategically use
              <CorteDesktop />
              the latest tech trends
              <CorteDesktop />
              to help you expand your
              <CorteDesktop />
              possibilities. Plus, our flexibility
              <CorteDesktop />
              enables us to adapt to any
              <CorteDesktop />
              technology, platform
              <CorteDesktop />
              or process you use.
            </p>
          </Card>
          <Card>
            <SVGContainer className="mb-35 mb-16-mobile">
              <Partnership
                xmlns="http://www.w3.org/2000/svg"
                width="58"
                height="38"
                viewBox="0 0 58 38"
                fill="none"
              >
                <path
                  d="M15.7835 17.9765C18.0632 17.9765 19.9113 16.1286 19.9113 13.849C19.9113 11.5695 18.0632 9.72156 15.7835 9.72156C13.5038 9.72156 11.6558 11.5695 11.6558 13.849C11.6558 16.1286 13.5038 17.9765 15.7835 17.9765Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
                <path
                  d="M42.2225 17.9765C44.5022 17.9765 46.3502 16.1286 46.3502 13.849C46.3502 11.5695 44.5022 9.72156 42.2225 9.72156C39.9428 9.72156 38.0947 11.5695 38.0947 13.849C38.0947 16.1286 39.9428 17.9765 42.2225 17.9765Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
                <path
                  d="M28.4433 7.93992C28.9808 7.84785 29.5332 7.96953 29.9822 8.27896C30.4313 8.5884 30.7415 9.06105 30.8469 9.5961C30.9305 10.0454 32.9786 20.4529 42.4202 20.4529H42.6554C52.9592 20.4529 57.1288 29.7476 57.9126 34.7633C58.0091 35.3032 57.8895 35.8593 57.5796 36.3118C57.2698 36.7644 56.7946 37.077 56.2563 37.1823C56.1325 37.2074 56.0063 37.2198 55.88 37.219C55.3888 37.2132 54.9152 37.0345 54.5426 36.7144C54.1699 36.3943 53.9221 35.9534 53.8423 35.4687C53.79 35.1395 52.8233 29.3297 48.5127 26.336C48.3977 26.2559 48.2631 26.2088 48.1233 26.1997C47.9836 26.1907 47.844 26.2201 47.7197 26.2847C47.5954 26.3493 47.4911 26.4465 47.4182 26.5661C47.3452 26.6856 47.3062 26.8227 47.3056 26.9628V35.6149H36.0249V24.0318C36.0237 23.7825 35.9557 23.5382 35.828 23.3241C35.7003 23.11 35.5174 22.9339 35.2986 22.8144C29.9691 19.8729 27.4351 13.9325 26.7819 10.338C26.6915 9.80052 26.8144 9.24891 27.1248 8.80092C27.4352 8.35293 27.9083 8.04409 28.4433 7.93992Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M28.9994 7.91958C29.1833 7.90161 29.3703 7.90795 29.5555 7.93968C30.0896 8.04502 30.5614 8.35435 30.8707 8.80221C31.18 9.25006 31.3024 9.80103 31.2118 10.3377C31.1871 10.4694 31.16 10.6043 31.1303 10.742C30.9453 10.1044 30.8624 9.67912 30.8469 9.59586C30.7415 9.0608 30.4313 8.58815 29.9823 8.27872C29.6879 8.07591 29.3492 7.95376 28.9994 7.91958ZM26.8644 10.7564C26.0458 13.5686 23.2574 20.4526 15.5786 20.4526H15.3434C5.03448 20.4526 0.870304 29.7474 0.0865525 34.7631C-0.0101596 35.3022 0.108661 35.8576 0.417452 36.3101C0.726244 36.7625 1.20015 37.0756 1.73748 37.182C1.86309 37.2069 1.99085 37.2193 2.1189 37.2188C2.6101 37.213 3.08363 37.0342 3.45627 36.7141C3.82892 36.3941 4.07681 35.9531 4.1566 35.4684C4.20885 35.1393 5.17558 29.3295 9.48621 26.3357C9.60115 26.2557 9.73576 26.2085 9.87553 26.1995C10.0153 26.1905 10.1549 26.2199 10.2791 26.2845C10.4034 26.349 10.5077 26.4463 10.5807 26.5658C10.6537 26.6854 10.6926 26.8225 10.6932 26.9625V35.6146H21.9739V24.0316C21.974 23.782 22.0418 23.5372 22.1696 23.3229C22.2974 23.1086 22.4807 22.9328 22.7003 22.8142C25.5593 21.2362 27.6063 18.7953 28.9938 16.3164C27.8899 14.3495 27.2036 12.3588 26.8644 10.7564Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
                <g style={{ mixBlendMode: "multiply" }}>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.1302 10.742C30.9452 10.1044 30.8622 9.6791 30.8468 9.59584C30.7414 9.06078 30.4312 8.58814 29.9821 8.2787C29.6878 8.07589 29.3491 7.95374 28.9993 7.91956C28.6495 7.95374 28.3108 8.07589 28.0165 8.2787C27.5674 8.58814 27.2572 9.06078 27.1519 9.59584C27.1363 9.67973 27.0522 10.1108 26.8643 10.7564C27.2035 12.3588 27.8898 14.3495 28.9937 16.3164C30.0979 14.3436 30.7845 12.3469 31.1302 10.742Z"
                    fill="#060045"
                  />
                </g>
                <path
                  d="M27.916 1.52919V3.96907C27.916 4.48846 28.337 4.90967 28.8564 4.90967H29.123C29.6424 4.90967 30.0634 4.48846 30.0634 3.96907V1.52919C30.0634 1.0098 29.6424 0.588852 29.123 0.588852H28.8564C28.337 0.588852 27.916 1.0098 27.916 1.52919Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
                <path
                  d="M34.6395 3.73501L32.9142 5.46027C32.5469 5.82753 32.5469 6.4232 32.9142 6.79047L33.1025 6.97879C33.4698 7.34606 34.0653 7.34588 34.4326 6.97861L36.158 5.25336C36.5253 4.88609 36.5253 4.29078 36.158 3.92352L35.9696 3.73519C35.6023 3.36792 35.0068 3.36774 34.6395 3.73501Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
                <path
                  d="M21.8221 5.25191L23.5474 6.97717C23.9147 7.34443 24.5103 7.34425 24.8775 6.97699L25.0659 6.78866C25.4332 6.4214 25.4332 5.82609 25.0659 5.45882L23.3405 3.73356C22.9732 3.3663 22.3777 3.36612 22.0104 3.73338L21.8221 3.92171C21.4548 4.28898 21.4548 4.88465 21.8221 5.25191Z"
                  fill={
                    theme.nombre === "light" ? colors.lilaush : colors.verdeush
                  }
                />
              </Partnership>
            </SVGContainer>
            <h3 className="title-card mb-35 body-bold-mobile mb-16-mobile">
              Partnership
            </h3>
            <p className="texto-regular text-center txt-regular-mobile">
              Positive leadership, empathy
              <CorteDesktop /> and honesty are our core work
              <CorteDesktop /> values. We strongly believe the
              <CorteDesktop /> collaborative effort of a team
              <CorteDesktop /> to achieve a common goal leads
              <CorteDesktop /> to much more effective and efficient solutions.
              <CorteDesktop /> Better together!
            </p>
          </Card>
        </CardContainer>

        <OndasLargas />
      </Container>
    </>
  );
}

export default MeetYourLanguage;
